
import { SolutionDetails, SolutionMetadata } from '@/types/solution';

export const createSolutionTemplate = (
  name: string = "",
  shortDescription: string = "",
  category: string = "",
  tags: string[] = []
): SolutionDetails => {
  const metadata: SolutionMetadata = {
    name,
    shortDescription: shortDescription,
    category,
    tags
  };

  return {
    metadata,
    overview: "Brief overview of the solution",
    capabilities: [
      "Key capability 1",
      "Key capability 2",
      "Key capability 3"
    ],
    useCases: [
      "Use case 1",
      "Use case 2",
      "Use case 3"
    ],
    limitations: [
      "Limitation 1",
      "Limitation 2"
    ],
    longDescription: "More detailed description of the solution and its features...",
    officialWebsite: {
      title: "Official Website",
      url: "https://example.com"
    },
    externalLinks: [
      {
        title: "Documentation",
        url: "https://example.com/docs"
      },
      {
        title: "GitHub Repository",
        url: "https://github.com/example/repo"
      }
    ],
    versions: [
      {
        version: "1.0.0",
        status: "Stable",
        since: "January 2023",
        tags: ["initial release"]
      }
    ]
  };
};

export const createEmptyTemplate = (): SolutionDetails => {
  return {
    metadata: {
      name: "",
      shortDescription: "",
      category: "",
      tags: []
    },
    overview: "",
    capabilities: [],
    useCases: [],
    limitations: []
  };
};
